/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Import_Ai_DescInputs */

const en_resumes_import_ai_desc = /** @type {(inputs: Resumes_Import_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import a PDF or DOCX and let AI extract your details`)
};

const de_resumes_import_ai_desc = /** @type {(inputs: Resumes_Import_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importiere ein PDF oder DOCX und lass die KI deine Daten extrahieren`)
};

const fr_resumes_import_ai_desc = /** @type {(inputs: Resumes_Import_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe un PDF ou DOCX et laisse l'IA extraire tes informations`)
};

const es_resumes_import_ai_desc = /** @type {(inputs: Resumes_Import_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe un PDF o DOCX y deje que la IA extraiga sus datos`)
};

const it_resumes_import_ai_desc = /** @type {(inputs: Resumes_Import_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa un PDF o DOCX e lascia che l'AI estragga i tuoi dettagli`)
};

const nl_resumes_import_ai_desc = /** @type {(inputs: Resumes_Import_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importeer een PDF of DOCX en laat AI je gegevens extraheren`)
};

const pl_resumes_import_ai_desc = /** @type {(inputs: Resumes_Import_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaimportuj PDF lub DOCX i pozwól AI wyodrębnić Twoje dane`)
};

const fi_resumes_import_ai_desc = /** @type {(inputs: Resumes_Import_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuo PDF tai DOCX ja anna tekoälyn poimia tietosi`)
};

const da_resumes_import_ai_desc = /** @type {(inputs: Resumes_Import_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer en PDF eller DOCX og lad AI udtrække dine detaljer`)
};

const sv_resumes_import_ai_desc = /** @type {(inputs: Resumes_Import_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importera en PDF eller DOCX och låt AI extrahera dina uppgifter`)
};

/**
* | output |
* | --- |
* | "Import a PDF or DOCX and let AI extract your details" |
*
* @param {Resumes_Import_Ai_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_import_ai_desc = /** @type {((inputs?: Resumes_Import_Ai_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Import_Ai_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_import_ai_desc(inputs)
	if (locale === "fr") return fr_resumes_import_ai_desc(inputs)
	if (locale === "es") return es_resumes_import_ai_desc(inputs)
	if (locale === "it") return it_resumes_import_ai_desc(inputs)
	if (locale === "nl") return nl_resumes_import_ai_desc(inputs)
	if (locale === "pl") return pl_resumes_import_ai_desc(inputs)
	if (locale === "fi") return fi_resumes_import_ai_desc(inputs)
	if (locale === "da") return da_resumes_import_ai_desc(inputs)
	if (locale === "sv") return sv_resumes_import_ai_desc(inputs)
	return en_resumes_import_ai_desc(inputs)
});